export default defineNuxtRouteMiddleware(async (to) => {
  const { $i18n } = useNuxtApp();
  const locales = $i18n.locales.value.map(locale => locale.code);
  const defaultLocale = $i18n.locale.value;

  const match = to.fullPath.match(/^\/([a-z]{2})(\/|$|\?|#)/);
  const currentLocale = match ? match[1] : null;

  const browserLanguage = navigator?.language?.split('-')[0];
  const isBrowserLanguageValid = locales.includes(browserLanguage);
  const redirectLocale = isBrowserLanguageValid ? browserLanguage : defaultLocale;

  if (!currentLocale || !locales.includes(currentLocale)) {
    await clearError();
    return navigateTo(`/${redirectLocale}${to.fullPath}`);
  }
})
